// src/services/englishPracticeClientService.js
import { fetchFromBackend } from "../services/apiClient"; // Adjust path as needed

const SERVICE_PATH = "api/Dashboard";

/**
 * Helper function to handle common error logging and re-throwing.
 * Logs the full error in non-production environments and throws a user-friendly error.
 * @param {string} functionName - The name of the function where the error occurred.
 * @param {Error} error - The original error object.
 * @param {string} userFriendlyMessage - The message to show to the user.
 */
const handleError = (functionName, error, userFriendlyMessage) => {
  // Log the full error in development or test environments for debugging.
  // In production, we avoid logging sensitive or internal error details to the console.
  if (process.env.NODE_ENV !== "production") {
    console.error(`[${functionName}] Detailed error:`, error);
  }
  // Throw a new error with a user-friendly message, hiding internal details.
  throw new Error(userFriendlyMessage);
};

/**
 * Retrieves a proficiency assessment task from the backend.
 * @returns {Promise<object>} - The proficiency assessment task object.
 *   Example: { taskType: "read_aloud", title: "...", instructions: "...", content: { textToRead: "..." }, evaluationCriteria: "..." }
 */
export const getUserDashboard = async () => {
  try {
    return await fetchFromBackend(`${SERVICE_PATH}/user-dashboard`, {}, "GET");
  } catch (error) {
    handleError(
      "getDashboard",
      error,
      "Failed to get user dashboard. Please try again later."
    );
  }
};
